var React = require('react');

function MailIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m24.6269531 0h-22.25390622c-1.30686329 0-2.37304688 1.08747692-2.37304688 2.42307692v16.15384618c0 1.3310769 1.0614375 2.4230769 2.37304688 2.4230769h22.25390622c1.3035938 0 2.3730469-1.0838154 2.3730469-2.4230769v-16.15384618c0-1.33107692-1.0614375-2.42307692-2.3730469-2.42307692zm-.3276914 1.61538462-10.7489531 10.97562308-10.84192383-10.97562308zm-22.71723045 16.62704618v-15.49256157l7.61900977 7.71292307zm1.1186543 1.1421846 7.62380855-7.7845385 2.6713653 2.7042616c.3092344.3130615.8082597.3120384 1.1162285-.002477l2.604709-2.659623 7.5825176 7.7423769zm22.71728325-1.1422385-7.5825176-7.7423769 7.5825176-7.74243077z","transform":"matrix(-1 0 0 1 27 0)"}));
}

MailIconInline.defaultProps = {"height":"21","viewBox":"0 0 27 21","width":"27"};

module.exports = MailIconInline;

MailIconInline.default = MailIconInline;
